import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { get, post } from "../../../../common/api"
import { USERS, USERS_ADD, USERS_DETAILS } from '../../../../common/constant'

export const actionUsers = createAsyncThunk('appUsersSlice/actionUsers', async (thunkAPI) => {
    return await get(USERS, thunkAPI)
})

export const actionAddUsers = createAsyncThunk('appUsersSlice/actionAddUsers', async (params, thunkAPI) => {
    return await post(USERS_ADD, params, thunkAPI)
})

export const actionGetUsers = createAsyncThunk('appUsersSlice/actionGetUsers', async (params, thunkAPI) => {
    return await post(USERS_DETAILS, params, thunkAPI)
})

export const appUsersSlice = createSlice({
    name: 'appUsersSlice',
    initialState: {
        loadingUsers: false,
        users: null,

        loadingAddUsers: false,
        addUsers: null,

        loadingGetUsers: false,
        userDetails: null
    },
    reducers: {
        //reset or delete Add store data
        resetUsersResponse: (state) => {
            state.users = null
        },
        resetAddUsersResponse: (state) => {
            state.addUsers = null
        },
        resetGetUsersResponse: (state) => {
            state.userDetails = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionUsers.pending, (state) => {
                state.loadingUsers = true
            })
            .addCase(actionUsers.fulfilled, (state, action) => {
                state.loadingUsers = false
                state.users = action.payload
            })
            .addCase(actionUsers.rejected, (state) => {
                state.loadingUsers = false
            })

            //Add
            .addCase(actionAddUsers.pending, (state) => {
                state.loadingAddUsers = true
            })
            .addCase(actionAddUsers.fulfilled, (state, action) => {
                state.loadingAddUsers = false
                state.addUsers = action.payload
            })
            .addCase(actionAddUsers.rejected, (state) => {
                state.loadingAddUsers = false
            })
            //list
            .addCase(actionGetUsers.pending, (state) => {
                state.loadingGetUsers = true
            })
            .addCase(actionGetUsers.fulfilled, (state, action) => {
                state.loadingGetUsers = false
                state.userDetails = action.payload
            })
            .addCase(actionGetUsers.rejected, (state) => {
                state.loadingGetUsers = false
            })

    }
})
export const { resetUsersResponse, resetAddUsersResponse, resetGetUsersResponse} = appUsersSlice.actions

export default appUsersSlice.reducer